module.exports = __webpack_public_path__ + "img/google-play-badge.939e9018.svg";